
/* global TomSelect */

$.fn.defaultChosen = function() {
  var allowSingleDeselect = ($(this).data('allowSingleDeselect') === false) ? false : true;
  $(this).chosen({
    width: '100%',
    disable_search_threshold: 4,
    allow_single_deselect: allowSingleDeselect,
    search_contains: true,
    placeholder_text_single: " ",
    placeholder_text_multiple: " "
  });
};

const escapedSelectOptionStr = (text) => {
  if (typeof(text) === 'string' && text.startsWith('<em>') && text.endsWith('</em>')) {
    return '<em>' +  _.escape(text.replace(/^<em>/, '').replace(/<\/em>$/, '')) + '</em>';
  }
  else {
    return _.escape(text);
  }
};

$.fn.dynamicChosen = function() {
  var that = this;
  var chosenId = "#" + $(that).attr("id") + "_chosen";

  $(that).chosen({
    width: "100%",
    placeholder_text_multiple: " ",
    no_results_text: "Add ",
    display_selected_options: false
  });

  var addDynamicOption = function() {
    var newInputs = $(chosenId).find(".search-field input").val().split(',');
    $.each(newInputs, function(k,v) {
      var newInput = v.replace(/^\s+|\s+$/g,'');
      $(that).append($("<option>", {
        value: newInput,
        text : newInput,
        selected: "selected"
      }));
    });
    $(that).trigger("chosen:updated").trigger('change');
  };

  var removeDynamicOption = function(val) {
    if (!val || val === '') {
      return;
    }

    $(that).find("option[value='" + val.replace("'", "\\\'") + "']").remove();
    $(that).trigger("chosen:updated");
  };

  $("body").on("click", chosenId + " .no-results", addDynamicOption);
  $("body").on("keyup", chosenId + " .search-field input", function(e) {
    if (e.which == 13 && $(chosenId + ' li.no-results').length > 0) {
      addDynamicOption();
    }
  });

  $(that).on('change', function(e, params) {
    if (params && params.deselected) {
      removeDynamicOption(params.deselected);
    }
  });
};

$.fn.defaultTokenize = function() {
  var that = this;

  var setTokenUrl = function(value, text) {
    var option = $(that).find('option[value="' + value + '"]');
    var optionUrl = option.data('url');
    var optionClass = option.data('class');

    if (optionUrl) {
      if (!text.match(/^<a .*>$/)) {
        var span = $(that).parent().find('.tokens-container li[data-value="' + value + '"] span');
        const classString = optionClass ? " class='" + optionClass + "'" : '';
        const escapedText = escapedSelectOptionStr(text);
        const html = (optionUrl === '#') ? escapedText : "<a href='" + optionUrl + "' target='_blank'" + classString + ">" + escapedText + "</a>";
        span.html(html);
      }
    }
  };

  $(this).tokenize2({
    dataSource: $(this).data('ajax'),
    debounce: 100,
    delimiter: ';',
    placeholder: $(this).data('placeholder'),
    searchMinLength: $(this).data('searchMinLength') || 0,
    dropdownMaxItems: 100,
    tokensMaxItems: $(this).data('tokensMaxItems') || 0
  }).trigger('tokenize:remap');

  $(this).find('option:selected').each(function(i, option) {
    var optionElement = $(option);
    setTokenUrl(optionElement.val(), optionElement.text());
  });

  $(this).on('tokenize:select', function(container) {
    if ( $(this).prop('disabled') ) {
      return;
    }
    $(this).tokenize2().trigger('tokenize:search', [$(this).tokenize2().input.val()]);
  });

  $(this).on('tokenize:tokens:added', function(e, value, text) {
    setTokenUrl(value, text);
    $(that).trigger('change');
    $(that).parent().find('.tokenize').blur();
  });

  $(this).on('tokenize:tokens:remove', function(e, value) {
    $(that).trigger('change');
    $(that).parent().find('.tokenize').blur();
  });
};

$.fn.defaultTomSelect = function() {
  var select = this;

  if (select.get(0).tomselect) {
    return;
  }

  var setTokenUrl = function(optionElement) {
    var option = $(optionElement);
    var optionUrl = option.data('url');

    if (optionUrl) {
      var span = $(select).parent().find('.ts-control div[data-value="' + option.val() + '"]');
      var removalAnchor = $(span).find('a.remove');
      if ($(span).find('a:not(.remove)').length < 1) {
        const textWithoutEm = option.text().replace(/<\/?em>/gi, '');
        const escapedText = _.escape(textWithoutEm);
        const html = "<a href='" + optionUrl + "' target='_blank'>" + escapedText + "</a>";
        span.html(html);
        span.append(removalAnchor);
      }
    }
  };

  let plugins = [];

  if ($(select).attr('multiple') && $(select).data('maxItems') !== 1 && $(select).attr('disabled') !== 'disabled') {
    plugins = ['remove_button'];
  }
  else if ($(select).data('allowSingleDeselect') !== false) {
    plugins = ['clear_button'];
  }

  if ($(select).data('dropdownInput')) {
    plugins.push('dropdown_input');
  }

  var ajaxAttr = $(select).attr('data-ajax');
  var ajaxDataForPaging = $(select).data('ajax');
  var isHeaderAccountsSelect =
    $(select).data('headerAccountsPaging') === true ||
    (ajaxAttr && String(ajaxAttr).indexOf('header_accounts') !== -1) ||
    (ajaxDataForPaging && String(ajaxDataForPaging).indexOf('header_accounts') !== -1);

  // virtual_scroll has to appear first for hooks to work, no_backspace_delete stops empty-search backspace from clearing the current account
  if (isHeaderAccountsSelect) {
    plugins = ['virtual_scroll', 'no_backspace_delete'].concat(plugins);
  }
  const parseCustomData = (data) => {
    let customData = data.custom_data;
    // because this code is a mess `customData` can be either a JSON encoded string or a JS object
    if (typeof customData === "string") {
      try {
        customData = JSON.parse(customData);
      } catch (e) {
        // if it isn't valid JSON, use the original string to try and prevent ourselves from breaking this more than it already is
      }
    }
    return customData;
  };

  const defaultRenderOptionOrItem = (data, _escape) => {
    let customData = parseCustomData(data);
    const text = data.text != null ? String(data.text) : '';
    const hasEm = text.indexOf('<em>') !== -1;
    const displayText = text.replace(/<\/?em>/gi, '');
    return $(`<div></div>`)
      .toggleClass('ts-option-em', hasEm)
      .data("customData", customData)
      .html(displayText);
  };

  // Header accounts (data-header-accounts-paging or header_accounts URL): offset/limit paging
  // via Tom Select's virtual_scroll (see plugins above). Rows are JSON { value, text }.
  var SEARCHES_PAGE_SIZE = 50;

  var appendDemandPartnerPermissionParams = function(u) {
    var demandPartnerPermissionIds = $(select).data('demandPartnerPermissionIds');
    if (!demandPartnerPermissionIds) {
      return;
    }
    if (Array.isArray(demandPartnerPermissionIds)) {
      demandPartnerPermissionIds.forEach(function(id) {
        u.searchParams.append('demand_partner_permission_ids[]', id);
      });
    } else {
      u.searchParams.set('demand_partner_permission_ids', demandPartnerPermissionIds);
    }
  };

  var applySearchesDefaultLimit = function(u) {
    if (!u.searchParams.has('limit') && u.pathname.startsWith('/searches/')) {
      u.searchParams.set('limit', SEARCHES_PAGE_SIZE);
    }
  };

  // If `?` is missing before the first param, the whole string becomes pathname (e.g.
  // /searches/header_accountssearch=&limit=50) and searchParams behave badly. Repair the common case.
  var fixMalformedHeaderAccountsAjaxUrl = function (str) {
    if (typeof str !== 'string' || str.indexOf('header_accountssearch') === -1) {
      return str;
    }
    return str.replace(/\/header_accountssearch=/, '/header_accounts?search=');
  };

  var tomSelectAjaxUrlToString = function(u) {
    return u.hostname === 'example.com' ? u.pathname + u.search : u.toString();
  };

  var newTomSelectAjaxUrl = function() {
    // Prefer jQuery .data('ajax'): DatatableFilterLinkHelper updates it when the DC/managed
    // partner pill changes (.data('ajax', url) without rewriting the data-ajax attribute).
    // Reading only attr('data-ajax') would keep using the original URL and stale options.
    var raw = $(select).data('ajax') || ajaxAttr || $(select).attr('data-ajax');
    if (!raw) {
      return null;
    }
    if (typeof raw === 'object' && raw !== null && typeof raw.href === 'string') {
      raw = raw.href;
    } else if (typeof raw !== 'string') {
      raw = String(raw);
    }
    raw = fixMalformedHeaderAccountsAjaxUrl(raw);
    var u = new URL(raw, 'https://example.com');
    appendDemandPartnerPermissionParams(u);
    return u;
  };

  var headerAccountsBuildUrl = function(search, offset) {
    var u = newTomSelectAjaxUrl();
    if (!u) {
      return '';
    }
    u.searchParams.set('search', search);
    applySearchesDefaultLimit(u);
    u.searchParams.set('limit', SEARCHES_PAGE_SIZE);
    u.searchParams.set('offset', String(offset));
    return fixMalformedHeaderAccountsAjaxUrl(tomSelectAjaxUrlToString(u));
  };

  // custom option renderer for the "Ad Code" dropdown on Magnite SpringServe bidder demand tags
  const renderStreamingAdUnitOption = (data, _escape) => {
    let customData = parseCustomData(data);
    const displayName = customData?.supply_lineage || customData?.name || customData?.code || data?.text;
    return $(`<div></div>`).data("customData", customData)
      .append($('<span></span>').html(displayName))
      .append($('<span style="font-weight: bold;"></span>')
        .append(' (')
        .append($('<span></span>').html(customData?.code || data?.value))
        .append(')'));
  };
  const renderStreamingAdUnitItem = (data, _escape) => {
    let customData = parseCustomData(data);
    return $(`<div></div>`).data("customData", customData).html(customData?.code || data?.text);
  };

  let renderOptionFunc = defaultRenderOptionOrItem;
  let renderItemFunc = defaultRenderOptionOrItem;
  if ($(select).data('streaming-ad-unit-code')) {
    renderOptionFunc = renderStreamingAdUnitOption;
    renderItemFunc = renderStreamingAdUnitItem;
  }

  // Tom Select 2.5.2 fixed hideSelected with allowEmptyOption for value "". When both are
  // enabled, the selected "All …" option no longer appears in the list (e.g. DataTables
  // ajax column filters). Keep hiding selected rows for multi-select allowEmptyOption picks.
  var hideSelectedTomSelect =
    !(
      $(select).data('allowEmptyOption') &&
      !$(select).prop('multiple')
    );

  var ts = new TomSelect(select, {
    plugins: plugins,
    hidePlaceholder: true,
    hideSelected: hideSelectedTomSelect,
    highlight: false,
    preload: 'focus',
    shouldLoad: function (query) {
      // override default behavior to allow showing "No Results" message when no results are found on initial empty string search
      return true;
    },
    closeAfterSelect: $(select).data('closeAfterSelect') ? true : false,
    maxItems: $(select).data('maxItems'),
    ...(isHeaderAccountsSelect
      ? {
          maxOptions: 10000,
          refreshThrottle: 0,
          firstUrl: function (q) {
            return headerAccountsBuildUrl(q, 0);
          },
          // virtual_scroll defaults use clientHeight / (scrollHeight - scrollTop) > 0.9, which fires very late.
          // Match the old header picker: (scrollTop + clientHeight) / scrollHeight >= 0.62, plus short viewport.
          shouldLoadMore: function () {
            var el = this.dropdown_content;
            if (!el || el.clientHeight <= 0) {
              return false;
            }
            var sh = el.scrollHeight;
            if (sh <= 0) {
              return false;
            }
            if (sh <= el.clientHeight + 2) {
              return true;
            }
            var fromTopRatio = (el.scrollTop + el.clientHeight) / sh;
            if (fromTopRatio >= 0.62) {
              return true;
            }
            if (this.activeOption) {
              var selectable = this.selectable();
              var index = Array.from(selectable).indexOf(this.activeOption);
              if (index >= selectable.length - 3) {
                return true;
              }
            }
            return false;
          }
        }
      : {}),
    allowEmptyOption: $(select).data('allowEmptyOption') ? true : false,
    searchField: $(select).data('ajax') ? [] : ['text'],
    create: $(select).data('selectCustom') ? true : false,
    load: function (query, callback) {
      if (isHeaderAccountsSelect) {
        var selfTs = this;
        var url = selfTs.getUrl(query);
        if (!url) {
          callback();
          return;
        }
        if (typeof url === 'object' && url !== null && typeof url.href === 'string') {
          url = url.href;
        }
        url = fixMalformedHeaderAccountsAjaxUrl(String(url));
        var pageUrl = new URL(url, 'https://example.com');
        var offset = parseInt(pageUrl.searchParams.get('offset') || '0', 10);
        var finalUrlString = fixMalformedHeaderAccountsAjaxUrl(tomSelectAjaxUrlToString(pageUrl));
        fetch(finalUrlString)
          .then(function (response) {
            return response.json();
          })
          .then(function (json) {
            if (!Array.isArray(json)) {
              callback();
              return;
            }
            var mapped = [];
            for (var j = 0; j < json.length; j++) {
              var row = json[j];
              if (!row || row.value == null) {
                continue;
              }
              mapped.push({
                value: String(row.value),
                text: row.text != null ? String(row.text) : ''
              });
            }
            if (json.length === SEARCHES_PAGE_SIZE) {
              selfTs.setNextUrl(query, headerAccountsBuildUrl(query, offset + json.length));
            }
            callback(mapped);
          })
          .catch(function () {
            callback();
          });
        return;
      }

      var ajaxUrl = newTomSelectAjaxUrl();
      if (!ajaxUrl) {
        callback();
        return;
      }

      ajaxUrl.searchParams.set('search', query);
      applySearchesDefaultLimit(ajaxUrl);
      // remove the protocol/hostname/port from the url if the original url is a relative url
      var finalUrlString = tomSelectAjaxUrlToString(ajaxUrl);
      fetch(finalUrlString)
        .then((response) => response.json())
        .then((json) => {
          ts.clearOptions(); // It appends results when disabling search so have to clear first
          callback(json);
        })
        .catch(() => {
          callback();
        });
    },
    render: {
      option: renderOptionFunc,
      item: renderItemFunc,
      loading: function(data, escape){
        return '';
      },
      // Suppress the "No results" message on selects that set data-suppress-no-results
      // (e.g. to avoid a flash on empty-string preload before remote options load).
      ...($(select).data('suppressNoResults') ? {
        no_results: function(data, escape){
          return '<div></div>';
        }
      } : {})
    }
  });

  // Tom Select highlights options from mouseenter only; wheel-scroll moves the list under a stationary
  // cursor without firing enter/leave, so .active can stay on the wrong row. Match highlight to pointer
  // after scroll and after remote pages append (ignoreHover is true while using arrow keys).
  //
  // virtual_scroll + refreshOptions can also leave more than one .option.active in the DOM; strip strays so
  // only ts.activeOption stays highlighted (see orchidjs/tom-select#556 and similar reports).
  if (isHeaderAccountsSelect) {
    var pointerXY = { x: undefined, y: undefined };
    var syncPointerRaf = null;
    var dedupeDropdownActiveHighlight = function () {
      var content = ts.dropdown_content;
      if (!content) {
        return;
      }
      var keep = ts.activeOption;
      var nodes = content.querySelectorAll('.option.active');
      for (var i = 0; i < nodes.length; i++) {
        if (keep && nodes[i] === keep) {
          continue;
        }
        nodes[i].classList.remove('active');
        nodes[i].removeAttribute('aria-selected');
      }
    };
    var syncActiveUnderPointer = function () {
      syncPointerRaf = null;
      if (ts.ignoreHover || pointerXY.x === undefined || !ts.isOpen) {
        dedupeDropdownActiveHighlight();
        return;
      }
      var content = ts.dropdown_content;
      if (!content) {
        return;
      }
      var hit = document.elementFromPoint(pointerXY.x, pointerXY.y);
      if (!hit || !content.contains(hit)) {
        dedupeDropdownActiveHighlight();
        return;
      }
      var opt = hit.closest('[data-selectable]');
      if (opt && content.contains(opt)) {
        ts.setActiveOption(opt, false);
      }
      dedupeDropdownActiveHighlight();
    };
    var scheduleSyncActiveUnderPointer = function () {
      if (syncPointerRaf !== null) {
        return;
      }
      syncPointerRaf = requestAnimationFrame(function () {
        syncActiveUnderPointer();
      });
    };
    ts.dropdown.addEventListener(
      'mousemove',
      function (e) {
        pointerXY.x = e.clientX;
        pointerXY.y = e.clientY;
      },
      true
    );
    ts.dropdown_content.addEventListener(
      'scroll',
      scheduleSyncActiveUnderPointer,
      { passive: true }
    );
    ts.on('load', function () {
      scheduleSyncActiveUnderPointer();
      requestAnimationFrame(function () {
        dedupeDropdownActiveHighlight();
      });
    });
  }

  // For the Demand Partner Expansion feature we need to limit what options can be selected to only those that share a
  // demand partner with the object being edited
  if ($(select).data('demandPartnerPermissionsInputId')) {
    // this gets the form element used to select the current page's demand partner
    const demandPartnerPermissionsSelector = '#' + $(select).data('demandPartnerPermissionsInputId');
    const demandPartnerPermissionsElement = $(demandPartnerPermissionsSelector);

    const updateStateForCurrentDemandPartnerPermissions = function (demandPartnerPermissionsTomSelect) {
      const demandPartnerPermissionIds = demandPartnerPermissionsTomSelect
        ? demandPartnerPermissionsTomSelect.getValue()
        : demandPartnerPermissionsElement.val();

      const input = $(select)
      const tomSelect = input.get(0)?.tomselect;

      // We will use the data-demand-partner-permission-ids attribute for filtering
      input.data('demandPartnerPermissionIds', demandPartnerPermissionIds);

      if (!demandPartnerPermissionIds || (Array.isArray(demandPartnerPermissionIds) && demandPartnerPermissionIds.length <= 0)) {
        tomSelect.disable();
        $(tomSelect.wrapper).data("toggle", "tooltip");
        $(tomSelect.wrapper).data("placement", "top");
        $(tomSelect.wrapper).data("container", "body");
        $(tomSelect.wrapper).attr("title", "Demand Partner required")
      } else {
        $(tomSelect.wrapper).removeData("toggle");
        $(tomSelect.wrapper).removeData("placement");
        $(tomSelect.wrapper).removeData("container");
        $(tomSelect.wrapper).removeAttr("title")
        tomSelect.enable();
      }

      input.trigger("ajax-change");
    };

    const demandPartnerPermissionsTomSelect = demandPartnerPermissionsElement.get(0)?.tomselect;
    if (demandPartnerPermissionsTomSelect) {
      demandPartnerPermissionsTomSelect.on('change', function () {
        $(select).get(0)?.tomselect?.setValue(null);
        updateStateForCurrentDemandPartnerPermissions(demandPartnerPermissionsTomSelect);
      });
    }

    updateStateForCurrentDemandPartnerPermissions(demandPartnerPermissionsTomSelect);
  }

  ts.on('item_add', function(value, item) {
    var optionElement = $(select).find('option[value="' + value + '"]');

    if (optionElement) {
      setTokenUrl(optionElement);
    }
  });

  ts.on("blur", function () {
    //clear out the query whenever the dropdown is closed, whether just on blur, or on select
    if (ts.items.length === 0) {
      ts.addItem("", true);
    }
    if (ts.lastQuery) {
      ts.lastQuery = null;
      ts.clearOptions();
      ts.wrapper.classList.remove("preloaded"); // allow tomselect to reload the options with empty search again
      if (typeof ts.clearPagination === 'function') {
        ts.clearPagination();
      }
    }
  });

  // trigger custom event to clear the search query whenever the ajax changes
  $(select).on("ajax-change", function () {
    ts.lastQuery = null;
    ts.wrapper.classList.remove("preloaded"); // allow tomselect to reload the options with empty search again
    ts.clearOptions();
    if (typeof ts.clearPagination === 'function') {
      ts.clearPagination();
    }
  });

  ts.refreshItems();

  $(select).find('option:selected').each(function(i, optionElement) {
    setTokenUrl(optionElement);
  });

  /**
   * Helper function to enable or disable loading of options for the tomselect, including
   * preload with empty query string
   * @param {*} enabled
   */
  ts.setLoadEnabled = function(enabled) {
    if (enabled) {
      ts.settings.preload = 'focus';
      ts.settings.shouldLoad = function() { return true; };
    } else {
      ts.settings.preload = false;
      ts.settings.shouldLoad = function() { return false; };
    }
  };
};

jQuery.propHooks.disabled = {
  set: function (el, value) {
    if (el.disabled !== value) {
      el.disabled = value;
      $(el).trigger('disabledChanged');
    }
  }
};

function initSelects() {
  $.each($("select[data-ajax]:not([data-tom-select])"), function(index, select){
    if (!select.tomselect) $(select).defaultTokenize();
  });
  $.each($("select[data-ajax][data-tom-select]"), function(index, select){
    if (!select.tomselect) $(select).defaultTomSelect();
  });
  $.each($("select[data-dynamic-chosen]"), function(index, select){
    if (!$(select).data('chosen')) $(select).dynamicChosen();
  });
  $.each($("select:not([data-ajax]):not([data-dynamic-chosen])"), function(index, select){
    if (!$(select).data('chosen')) $(select).defaultChosen();
  });

  $("option").on('disabledChanged', function(){
    $(this).parent("select").trigger("chosen:updated");
  });
}

// turbo:load handles every Turbo navigation (and the initial load on Turbo-enabled pages).
// $(document).ready() handles the initial load on pages that disable Turbo (e.g. the React
// layout sets <html data-turbo="false">). Because react-application.js is deferred,
// document.readyState is already "interactive" when chosen.js runs, so ready() fires
// immediately — before turbo:load or DOMContentLoaded can double-trigger. Guards in
// initSelects prevent re-initialization when both paths overlap.
$(document).on('turbo:load', initSelects);
$(document).ready(initSelects);

$(document).on('turbo:load', function() {
  $("body").on("click", ".chosen-container .chosen-choices .search-choice span", function(e){
    var closeLink = $(e.target).next("a.search-choice-close");
    if(closeLink.length){
      var select = closeLink.parents(".chosen-container").prev("select.chosen-clickable");
      if(select.length) {
        var option = select.find("option").eq(closeLink.data("optionArrayIndex"));
        var url = option.data("url");
        if(url){
          window.open(url, "_blank");
        }
      }
    }
  });

  $("body").on("mouseup", ".ts-wrapper .ts-control .item a:not(.remove)", function(e) {
    var url = $(this).attr('href');

    if (url) {
      window.open($(this).attr('href'), '_blank');
    }
  });

  $("body").on("click, mousedown", ".tokenize-dropdown li a", function(e){
    var linkTarget = $(e.target);
    linkTarget.parent().click();
    return false;
  });

  $('body').on('click', '.chosen-add-all', function(e) {
    var element = $(this);
    var target = element.data('target');
    var values = element.data('values');

    if (!target || !values) {
      return;
    }

    $(target).attr('disabled', false).val(values).trigger('chosen:updated');
  });

  $('body').on('click', '.chosen-remove-all', function(e) {
    var element = $(this);
    var target = element.data('target');

    if (!target) {
      return;
    }

    $(target).val([]).attr('disabled', true).trigger('chosen:updated');
  });
});
